export default __webpack_public_path__ + "static/3.xingyou-5596c790bb16c150708ea9ed8ba86689.png";